import React, { useState } from "react";
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Box, Button, Container, Typography, Tab, Tabs, useTheme, useMediaQuery, styled } from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import { phaseDetails } from '../../components/TembeaHighSchool/TembeaData';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-evenly',
  marginBottom: '20px',
  backgroundColor: '#f8f9fa',
  '& .MuiTab-root': {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '20px',
    backgroundColor: '#d9e5ff',
    cursor: 'pointer',
    marginRight: '5px',
    marginBottom: '5px',
    transition: 'all 0.3s ease',
    fontSize: '16px',
    '&.Mui-selected': {
      borderColor: '#007bff',
      backgroundColor: '#007bff',
      color: 'white',
    },
  },
}));

const PhaseContent = ({ phaseData, isMobile }) => {
  return (
    <Box sx={{ my: 2, border: '1px solid #ccc', borderRadius: 2, p: 2 }}>
      <Typography variant="h4" sx={{ textAlign: 'center', my: 2 }}>
        {phaseData.title}
      </Typography>
      <Box component="ul" sx={{
        pl: 2,
        mb: 1.5,
        listStyleType: 'none',
        m: 0,
        '& li:before': {
          content: '"•"',
          color: 'black',
          fontWeight: 'bold',
          display: 'inline-block',
          width: '1em',
          marginLeft: isMobile ? '-1rem' : '1rem'
        }
      }}>
        {phaseData.details.map((detail, index) => {
          switch (detail.type) {
            case "paragraph":
              return <Typography key={index} sx={{ mb: 1, marginLeft: isMobile ? '-1rem' : '1rem' }}>{detail.content}</Typography>;
            case "header":
              return <Typography variant="h5" key={index} sx={{ mb: 1 }}>{detail.content}</Typography>;
            case "item":
              return (
                <Box component="li" key={index} sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 1,
                  alignItems: 'center',
                  ...(isMobile && { fontSize: '0.875rem', mb: 0.5, justifyContent: 'flex-start', gap: 2 }),
                }}>
                  <Typography component="span" sx={{ flexGrow: 1 }}>
                    {detail.content.item}
                  </Typography>
                  <Typography component="span" sx={{ fontWeight: 'bold', color: 'black', ml: 2 }}>
                    {detail.content.cost}
                  </Typography>
                </Box>
              );
            case "total":
            case "received":
              return (
                <Typography key={index} sx={{ display: 'flex', justifyContent: 'space-between', my: 1.5, fontWeight: 'bold', color: 'black' }}>
                  <span>{detail.content.message}:</span>
                  <span style={{ fontSize: isMobile ? '1.05rem' : '1.25rem', fontWeight: 'bold' }}>{detail.content.amount}</span>
                </Typography>
              );
            default:
              return null;
          }
        })}
      </Box>
    </Box>
  );
};

const FundingNeeds = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeTab, setActiveTab] = useState(0);
  const phaseKeys = Object.keys(phaseDetails);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <NavBar />
      <Container maxWidth="lg" sx={{ my: isMobile ? 8 : 5, py: 5 }}>
        <Typography variant={isMobile ? 'h4' : 'h2'} gutterBottom textAlign="center" sx={{ fontWeight: 'bold' }}>
          Tembea Funding Needs
        </Typography>
        <Typography variant="body1" paragraph>
          Educated girls improve the standard of living for their families, make a positive impact on the environment, attend college, select a career and become role models and leaders in their communities and hopefully, the country.
        </Typography>
        <StyledBox sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 3,
          '.MuiTabs-flexContainer': {
            ...(isMobile
              ? { justifyContent: 'flex-start' }
              : { justifyContent: 'space-evenly', gap: theme.spacing(2) }
            ),
          },
        }}>
          <Tabs value={activeTab} onChange={handleChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="funding phases tabs">
            {phaseKeys.map((phase, index) => (
              <Tab label={phase} key={index} />
            ))}
          </Tabs>
        </StyledBox>

        {/* ToDo: add these color inside the tabs >  #f8f9fc; || background-color: #f8f9fa; ||  background-color: #d9e5ff; */}
        {phaseKeys.map((phase, index) => (
          <Box hidden={activeTab !== index} key={index}>
            <PhaseContent phaseData={phaseDetails[phase]} isMobile={isMobile} />
          </Box>
        ))}

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            component={RouterLink}
            to="/donate"
            endIcon={<FaPlus style={{ position: 'relative', top: '80%', transform: 'translateY(-80%)', fontSize: 'small' }} />}
            className="btn btn-border-base"
            sx={{
              borderRadius: '2.5rem',
              color: '#f39c12',
              border: '2px solid #f39c12',
              borderColor: '#f39c12',
              '& .MuiButton-endIcon': {
                mx: '0px',
              }
            }}
          >
            Learn More
          </Button>
        </Box>
      </Container>
      <FooterOne />
    </Box>
  );
};

export default FundingNeeds;
